/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { Text, TextProps } from '@getgo/chameleon-chakra-ui';
import React from 'react';

export const GoToHeadingText: React.FC<TextProps> = (props) => {
  return (
    <Text
      as='h2'
      fontSize='2.25rem'
      lineHeight='2.7rem'
      fontWeight={700}
      {...props}
    />
  );
};
